import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Heart, Camera, Wand2 } from 'lucide-react';
import { FloatingElements } from './FloatingElements';
export const Hero = () => {
  return <section id="home" className="relative min-h-screen flex items-center justify-center pt-20 pb-10 px-4 overflow-hidden" data-id="element-62">
      <FloatingElements data-id="element-63" />

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center gap-2 glass-card px-4 py-1.5 rounded-full text-pink-600 font-medium text-sm mb-8" data-id="element-65">
          <Heart className="w-4 h-4 fill-pink-400 text-pink-400" data-id="element-66" />
          100% Free Online Photobooth
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-5xl md:text-7xl font-bold text-pink-900 mb-6 leading-tight" data-id="element-67">
          Capture Your{' '}
          <span className="text-gradient-pink font-pacifico font-normal" data-id="element-68">
            Cute Moments
          </span>{' '}
          Instantly ✨
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-pink-700 mb-10 max-w-2xl font-quicksand" data-id="element-69">
          Free online photobooth with aesthetic filters and instant downloads.
          No login required, just pure pink vibes and cute memories.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-70">
          <a href="#photobooth" className="group relative flex items-center justify-center gap-2 bg-gradient-pink text-white px-8 py-4 rounded-full font-semibold text-lg hover:scale-105 hover:shadow-[0_0_20px_rgba(255,105,180,0.6)] transition-all duration-300 overflow-hidden" data-id="element-71">
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-72"></div>
            <Camera className="w-5 h-5 relative z-10" data-id="element-73" />
            <span className="relative z-10" data-id="element-74">Start Taking Photos</span>
          </a>

          <a href="#photobooth" className="flex items-center justify-center gap-2 glass-card text-pink-600 px-8 py-4 rounded-full font-semibold text-lg hover:bg-white/80 hover:scale-105 transition-all duration-300" data-id="element-75">
            <Wand2 className="w-5 h-5" data-id="element-76" />
            <span data-id="element-77">Try Cute Filters</span>
          </a>
        </motion.div>
      </div>
    </section>;
};